<div [formGroup]="innerFormControl" class="siblings">
  @for (control of siblings.controls; track control; let i = $index) {
    <div class="siblings--row" formArrayName="siblings">
      <div [formGroup]="control" class="siblings--inputs">
        <vdms-hq-ui-form-input-select
          [label]="'Sibling field type - #' + (i + 1)"
          formControlName="key"
          [selectOptions]="(allFieldsSelectOptions$ | async) ?? []"
        />
        @if (control.controls.key.value | definitionForSelectedId | async; as definition) {
          <vdms-hq-control [formControlName]="'value'" [definition]="definition" />
        }
      </div>
      <vdms-hq-ui-button [iconOnly]="true" icon="remove" (click)="removeSibling(i)" />
    </div>
  }

  <div class="siblings--footer">
    <vdms-hq-ui-button color="secondary" (click)="addSibling()">Add sibling</vdms-hq-ui-button>
  </div>
</div>
